import Vue from 'vue'

import 'primevue/resources/themes/saga-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import './css/prime.css'

import AutoComplete from 'primevue/autocomplete'
import Textarea from 'primevue/textarea'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import Password from 'primevue/password'
import Dropdown from 'primevue/dropdown'
import SelectButton from 'primevue/selectbutton'
import Checkbox from 'primevue/checkbox'
import Calendar from 'primevue/calendar'
import Sidebar from 'primevue/sidebar'
import Tooltip from 'primevue/tooltip'
import Dialog from 'primevue/dialog'
import Listbox from 'primevue/listbox'
import RadioButton from 'primevue/radiobutton'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import Galleria from 'primevue/galleria'
import Menu from 'primevue/menu'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ColumnGroup from 'primevue/columngroup'
import ProgressBar from 'primevue/progressbar'
import Chart from 'primevue/chart'
import Rating from 'primevue/rating'
import Toast from 'primevue/toast'
import InputSwitch from 'primevue/inputswitch'
import BadgeDirective from "primevue/badgedirective";
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Slider from 'primevue/slider'
import FileUpload from "primevue/fileupload/FileUpload";
import Divider from "primevue/divider";
import Card from "primevue/card";
import MultiSelect from "primevue/multiselect/MultiSelect";
import Message from "primevue/message/Message.vue";

Vue.directive('tooltip', Tooltip)
Vue.directive('badge', BadgeDirective);

Vue.component('AutoComplete', AutoComplete)
Vue.component('Textarea', Textarea)
Vue.component('InputText', InputText)
Vue.component('InputNumber', InputNumber)
Vue.component('InputMask', InputMask)
Vue.component('Password', Password)
Vue.component('Dropdown', Dropdown)
Vue.component('SelectButton', SelectButton)
Vue.component('Checkbox', Checkbox)
Vue.component('Calendar', Calendar)
Vue.component('Sidebar', Sidebar)
Vue.component('Dialog', Dialog)
Vue.component('Listbox', Listbox)
Vue.component('RadioButton', RadioButton)
Vue.component('TabView', TabView)
Vue.component('TabPanel', TabPanel)
Vue.component('Galleria', Galleria)
Vue.component('Menu', Menu)
Vue.component('DataTable', DataTable)
Vue.component('Column', Column)
Vue.component('ColumnGroup', ColumnGroup)
Vue.component('ProgressBar', ProgressBar)
Vue.component('Chart', Chart)
Vue.component('Rating', Rating)
Vue.component('Toast', Toast)
Vue.component('InputSwitch', InputSwitch)
Vue.component('Accordion', Accordion)
Vue.component('AccordionTab', AccordionTab)
Vue.component('Slider', Slider)
Vue.component('FileUpload', FileUpload)
Vue.component('Divider', Divider)
Vue.component('Card', Card)
Vue.component('MultiSelect', MultiSelect)
Vue.component('Message', Message)
